var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$appConfig.keycloakClient === 'noosacoasts')?_c('map-compare',{on:{"mapLoaded":_vm.addLayer}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }